module.exports = __webpack_public_path__ + "img/businesscarimg.c37e8c04.jpg";